var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as CryptoJS from "crypto-js";
import _, { isEmpty, orderBy } from "lodash";
import moment from "moment";
// import { getSensexExpiryDummyData } from "src/apis/mock/data/get-sensex-expiry-data";
// import { getSensexOptionsDummyData } from "src/apis/mock/data/get-sensex-options";
import { getChartTokenSocket, getElasticSearchDataNew, getExpiryFromSymbol, getFNOScriptsAndIndex, getOptionsFromSymbol, } from "../apis/dashboard";
import { getSymbolsDummyData } from "../apis/mock/data/get-symbols";
const { REACT_APP_ENV, REACT_APP_QUANTSAPP_KEY } = process.env;
import { AUTORIZATION_SMART_STRATEGIES, CALL_OPTION_TYPE, CASH_PRODUCT, COMMODITY_SEGMENT, CURRENCY_SEGMENT, DATE_FORMAT, DEFAULT_GREEK_OPTIONS, EQUITY_SEGMENT, FUTURES_PRODUCT, FUTURE_ABBREVATED, GREEKS_TOKEN_DATA, OPTIONS_PRODUCT, PREFERENCE_DATA, PUT_OPTION_TYPE, SOCKET_SUBSCRIPTION_METHODS, SOLACE_20DEPTH_TOPIC_PREFIX, SOLACE_GREEKS_TOPIC_PREFIX, VTT_STATUS, } from "./constant";
import { remoteConfigData } from "./custom-remote-config";
import { SESSION_KEYS, getDataFromSession, removeFromSession, setDataInSession, } from "./session-storage";
import { NavPaths } from "src/config/routes";
import { dashboardWorkerRef } from "src/apis/dashboard.controller";
import { ToastUtils } from "./toast-utils";
const { REACT_APP_URL_CHART } = process.env;
let toastMessageEnabled = false;
function getJsonFromXml(data) {
    const startIndex = data.indexOf("[");
    const endIndex = data.indexOf("]") + 1;
    const finalData = data.substring(startIndex, endIndex);
    const dataArray = JSON.parse(finalData);
    return dataArray;
}
function getDateTimestampFromDate(date) {
    const str1 = date.split("+")[0];
    const stamp = str1.split("(")[1];
    return stamp;
}
function triggerDate(value) {
    let a = value;
    a = a.substring(6, 19);
    const c = Number(a);
    const d = new Date(c);
    const e = d.toString();
    const date = e.substring(8, 10);
    const month = e.substring(4, 7).toUpperCase();
    const year = e.substring(11, 15);
    const finalValue = month + " " + date + ", " + year;
    return finalValue;
}
// function encrypt(data: string): string {
//   const key = enc.Hex.parse("842a357c4b385726090aa184b75b691075da95e6ddd4eb40");
//   const iv = enc.Hex.parse("53471a3a3623160b53471a3a3623160b");
//   const encrypted = AES.encrypt(data, key, { iv: iv });
//   return encrypted.toString();
// }
let userPreference = undefined;
function encrypt(inputData) {
    const keyValue = "842a357c4b385726090aa184b75b691075da95e6ddd4eb40";
    // const keyValue = "842a357c4b385726090aa184b75b691075da95e6ddd4eb40"; //-- For Crpto
    const ivValue = "53471a3a3623160b53471a3a3623160b"; // for Cropto
    // const keyvalue = this.constantService.keyValue;
    // let keyvalue = Buffer.from([132, 42, 53, 124, 75, 56, 87, 38,
    //   9, 10, 161, 132, 183, 91, 105, 16,
    //   117, 218, 149, 230, 221, 212, 235, 64]).toString('hex');
    // const ivValue = this.constantService.ivValue;
    // let ivValue = Buffer.from([83, 71, 26, 58, 54, 35, 22, 11,
    //   83, 71, 26, 58, 54, 35, 22, 11]).toString('hex');
    const _key = CryptoJS.enc.Hex.parse(keyValue);
    const _iv = CryptoJS.enc.Hex.parse(ivValue);
    // let encrypted = CryptoJS.AES.encrypt(
    //   CryptoJS.enc.Utf8.parse(inputData), _key, {
    //   iv: _iv
    // });
    // var encryptedOP = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    // return encryptedOP;
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(inputData), _key, {
        keySize: 128 / 8,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedOP = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    return encryptedOP;
}
export function decrypt(inputData) {
    const keyValue = "SL715111";
    const encryptionKey = keyValue; // Replace with your encryption key
    // Decrypt the data
    // const dataToEncrypt = "webapp";
    // const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, encryptionKey);
    const solaceClient = getDataFromSession(SESSION_KEYS.SOLACE_CLIENT);
    const decrypted = CryptoJS.AES.decrypt(solaceClient, encryptionKey);
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedString;
}
export const newDecrypt = (solaceCred) => {
    try {
        const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
        const slkeys = "SL" + clientCode.slice(2, 8);
        const key = CryptoJS.enc.Utf16LE.parse(slkeys);
        const iv = CryptoJS.enc.Hex.parse("53471a3a3623160b53471a3a3623160b"); // Hex representation of the original byte array
        const decrypted = CryptoJS.AES.decrypt(solaceCred, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const value = decrypted.toString(CryptoJS.enc.Utf8);
        const cred = value.split("|")[0];
        if (cred == "" || cred == undefined || cred == null || !cred) {
            // checkAndLogMessage(SOLACE_CONNECTION_FAILED, {
            //   reason: "SOLACE_CREDENTIAL_DECRYPTION_FAILED",
            //   solaceCred: solaceCred,
            //   slkeys: slkeys,
            // });
        }
        return cred;
    }
    catch (ex) {
        console.error("Error in decrypting solace credentials", ex);
        // checkAndLogMessage(SOLACE_CONNECTION_FAILED, {
        //   reason: "SOLACE_DECRYPTION_FAILED",
        //   decryptionError: ex,
        //   solaceCred: solaceCred,
        // });
    }
};
const splitAndGetDetailsFromLongName = (singleString, isFuture) => {
    const splitString = isFuture
        ? singleString.trim().split(" ")
        : singleString.replace(" FUT", "").trim().split(" ");
    let expiry, scripType, strikeRate;
    const isContainsApostrophe = singleString.includes("'");
    if (isContainsApostrophe) {
        if (splitString.length > 1) {
            const splitString2 = splitString[2] ? splitString[2] : "";
            expiry = splitString[1] + " " + splitString2;
        }
        if (splitString.length > 2) {
            scripType = splitString[3]; //CE - Call , PE - Put
        }
        else {
            // scripType = "FUT";
        }
        if (splitString.length > 3) {
            strikeRate = isEmpty(splitString[4])
                ? undefined
                : parseFloat(splitString[4]);
        }
    }
    else {
        if (splitString.length > 2) {
            const splitString2 = splitString[2] ? splitString[2] : "";
            const splitString3 = splitString[3] ? splitString[3] : "";
            expiry = splitString[1] + " " + splitString2 + " " + splitString3;
        }
        if (splitString.length > 3) {
            scripType = splitString[4]; //CE - Call , PE - Put
        }
        else {
            // scripType = "FUT";
        }
        if (splitString.length > 4) {
            strikeRate = isEmpty(splitString[5])
                ? undefined
                : parseFloat(splitString[5]);
        }
    }
    return {
        name: splitString[0],
        expiry,
        scripType,
        strikeRate,
    };
};
const splitAndGetDetailsFromLongNameForBuySell = (singleString) => {
    const splitString = singleString.replace(" FUT", "").split(" ");
    let expiry, scripType, strikeRate;
    if (splitString.length > 1) {
        const splitString2 = splitString[2] ? splitString[2] : "";
        expiry = splitString[1] + " " + splitString2;
    }
    if (splitString.length > 2) {
        scripType = splitString[3]; //CE - Call , PE - Put
    }
    else {
        // scripType = "FUT";
    }
    if (splitString.length > 3) {
        strikeRate = isEmpty(splitString[4])
            ? undefined
            : parseFloat(splitString[4]);
    }
    return {
        name: splitString[0],
        expiry,
        scripType,
        strikeRate,
    };
};
const getScripType = (singleString, exchange, exchangeType) => {
    let scripType = "";
    let subScripType = "";
    if (exchangeType == "C") {
        scripType = "CASH";
    }
    else if (exchangeType == "U") {
        scripType = "CURR";
    }
    else if (exchangeType == "D") {
        scripType = "OPTION";
    }
    if (exchange == "M") {
        scripType = "MCX";
    }
    if (exchangeType == "D" || exchangeType == "U") {
        if (singleString.toLowerCase().includes(" ce")) {
            subScripType = "CALL";
        }
        else if (singleString.toLowerCase().includes(" pe")) {
            subScripType = "PUT";
        }
        else {
            subScripType = "FUT";
        }
    }
    return { scripType, subScripType };
};
// const getScripType = (
//   singleString: string,
//   exchange: string,
//   exchangeType: string
// ): { scripType: string; subScripType: string } => {
//   let scripType = "";
//   let subScripType = "";
//   const segmentTypeObj = getSegmentAndProductType(
//     singleString,
//     exchange,
//     exchangeType
//   );
//   if (segmentTypeObj.subProductType == "CASH") {
//     scripType = "CASH";
//   } else if (segmentTypeObj.segmentType == "CURRENCY") {
//     scripType = "CURR";
//   } else if (segmentTypeObj.segmentType == "OPTIONS") {
//     scripType = "OPTION";
//   } else if (segmentTypeObj.segmentType == "COMMODITY") {
//     scripType = "MCX";
//   }
//   subScripType = segmentTypeObj.subProductType;
//   return { scripType, subScripType };
// };
const getSegmentAndProductType = (singleString, exchange, exchangeType) => {
    let segmentType = "";
    let productType = "";
    let subProductType = "";
    let subPType = "";
    if (exchange == "M") {
        segmentType = COMMODITY_SEGMENT;
    }
    else if (exchangeType == "U") {
        segmentType = CURRENCY_SEGMENT;
    }
    else {
        segmentType = EQUITY_SEGMENT;
    }
    if (exchangeType == "C") {
        productType = CASH_PRODUCT;
        subProductType = CASH_PRODUCT;
    }
    else if (exchangeType == "D" || exchangeType == "U") {
        if (singleString.toLowerCase().includes(" ce")) {
            productType = OPTIONS_PRODUCT;
            subProductType = CALL_OPTION_TYPE;
            subPType = "CE";
        }
        else if (singleString.toLowerCase().includes(" pe")) {
            subProductType = PUT_OPTION_TYPE;
            productType = OPTIONS_PRODUCT;
            subPType = "PE";
        }
        else {
            productType = FUTURES_PRODUCT;
            subProductType = FUTURE_ABBREVATED;
            subPType = "FUT";
        }
    }
    return {
        segmentType: segmentType,
        productType: productType,
        subProductType: subProductType,
        subPType: subPType,
    };
};
const getCookie = (cname) => {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};
const checkIsEmpty = (inputValue) => {
    let returnValue = false;
    // '"string" | "number" | "bigint" | "boolean" | "symbol" | "undefined" | "object" | "function"'
    if (inputValue == undefined) {
        returnValue = true;
    }
    else {
        if (typeof inputValue === "string") {
            returnValue = inputValue.length == 0;
        }
        else if (typeof inputValue === "number" ||
            typeof inputValue === "bigint") {
        }
        else if (typeof inputValue === "boolean") {
            returnValue = inputValue;
        }
        else if (typeof inputValue === "undefined") {
            returnValue = true;
        }
        else if (typeof inputValue === "object") {
            if (Array.isArray(inputValue)) {
                returnValue = inputValue.length == 0;
            }
        }
    }
    return returnValue;
};
const getSymbols = () => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const symbols = getDataFromSession(SESSION_KEYS.FNO_SYMBOL);
        if (REACT_APP_ENV == "development") {
            const scripts = getSymbolsDummyData();
            let symbolsList = scripts.map((script) => {
                return script.Symbol;
            });
            if (!symbolsList.find((script) => {
                script.toUpperCase() == "SENSEX";
            })) {
                symbolsList.push("SENSEX");
            }
            if (!symbolsList.find((script) => {
                script.toUpperCase() == "MIDCPNIFTY";
            })) {
                symbolsList.push("MIDCPNIFTY");
            }
            // Hiding BANKEX
            // if (
            //   !symbolsList.find((script) => {
            //     script.toUpperCase() == "BANKEX";
            //   })
            // ) {
            //   symbolsList.push("BANKEX");
            // }
            symbolsList = symbolsList.sort((a, b) => a.localeCompare(b));
            resolve(symbolsList);
        }
        else if (!symbols) {
            getFNOScriptsAndIndex()
                .then((result) => {
                const scripts = result.data;
                let symbolsList = scripts.map((script) => {
                    return script.Symbol;
                });
                if (!symbolsList.find((script) => {
                    script.toUpperCase() == "SENSEX";
                })) {
                    symbolsList.push("SENSEX");
                }
                if (!symbolsList.find((script) => {
                    script.toUpperCase() == "MIDCPNIFTY";
                })) {
                    symbolsList.push("MIDCPNIFTY");
                }
                // Hiding BANKEX
                // if (
                //   !symbolsList.find((script) => {
                //     script.toUpperCase() == "BANKEX";
                //   })
                // ) {
                //   symbolsList.push("BANKEX");
                // }
                symbolsList = symbolsList.sort((a, b) => a.localeCompare(b));
                resolve(symbolsList);
                setDataInSession(SESSION_KEYS.FNO_SYMBOL, symbolsList, true);
            })
                .catch(() => {
                reject();
            });
        }
        else {
            resolve(symbols);
        }
    });
});
const getOptionExpiryListWithCaching = (symbol, exchange) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        let disableCache = false;
        if (remoteConfigData) {
            disableCache = remoteConfigData.disableExpiryCache;
        }
        const expiryData = getDataFromSession(SESSION_KEYS + symbol);
        if (!expiryData || disableCache) {
            getExpiryFromSymbol(symbol, exchange)
                .then((result) => {
                const expiryList = result.data.body.Expiry;
                const status = result.data.body.Status;
                // const expiryList = getSensexExpiryDummyData().body.Expiry;
                // const status = getSensexExpiryDummyData().body.Status;
                if (status == 0) {
                    const currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    let filterList = expiryList.filter((singleData) => {
                        const millisString = getMillisFromDateString(singleData.ExpiryDate);
                        return moment(millisString).isSameOrAfter(currentDate);
                    });
                    filterList = orderBy(filterList, ["ExpiryDate"]);
                    resolve(filterList);
                    if (!disableCache) {
                        setDataInSession(SESSION_KEYS.FNO_EXPIRY + symbol, filterList, true);
                    }
                }
                else {
                    resolve([]);
                }
            })
                .catch(() => {
                reject();
            });
        }
        else {
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            const localExpiryData = expiryData;
            const filterList = localExpiryData.filter((singleData) => {
                const millisString = getMillisFromDateString(singleData.ExpiryDate);
                return moment(millisString).isSameOrAfter(currentDate);
            });
            resolve(filterList);
            if (localExpiryData.length > filterList.length) {
                setDataInSession(SESSION_KEYS.FNO_EXPIRY + symbol, filterList, true);
            }
        }
    });
});
const getMWPLBanListApiWithWorker = (controllerId) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        dashboardWorkerRef
            .getMWPLBanlistImpl(controllerId)
            .then((result) => {
            if (result.data.body) {
                resolve(result);
            }
        })
            .catch(() => {
            reject();
        });
    });
});
const getExpiryDateOptionChainWithCaching = (symbol, exch, exchType, expiry, controllerId) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        let disableCache = false;
        if (remoteConfigData) {
            disableCache = remoteConfigData.disableExpiryCache;
        }
        const expiryData = getDataFromSession(SESSION_KEYS + symbol);
        if (!expiryData || disableCache) {
            dashboardWorkerRef
                .getOptionChainForSymbolImpl(symbol, exch, exchType, expiry, controllerId)
                .then((result) => {
                var _a, _b;
                if ((result === null || result === void 0 ? void 0 : result.data) == "canceled") {
                    resolve({
                        filterList: [],
                        sortOptionChainData: [],
                        futExpiry: (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.FutExpiry,
                        lastrate: result === null || result === void 0 ? void 0 : result.data.Lastrate,
                        Status: "cancelled",
                    });
                }
                //console.log(result.data, "===");
                // const expiryList = result.data?.OptExpiry;
                const optionChainData = (_b = result.data) === null || _b === void 0 ? void 0 : _b.data.Options;
                if (result.data.data.Status == 0) {
                    const sortOptionChainData = _.orderBy(optionChainData, ["StrikeRate"], ["asc"]);
                    const optionchainData = {
                        sortOptionChainData: sortOptionChainData,
                        lastrate: result.data.data.Lastrate,
                    };
                    resolve(optionchainData);
                    //resolve(sortOptionChainData);
                    if (!disableCache) {
                        setDataInSession(SESSION_KEYS.FNO_OPTIONS + symbol + "-" + expiry, sortOptionChainData, true);
                    }
                }
                else {
                    const optionchainData = {
                        filterList: undefined,
                        sortOptionChainData: undefined,
                        futExpiry: undefined,
                        lastrate: undefined,
                    };
                    resolve(optionchainData);
                }
            })
                .catch(() => {
                reject();
            });
        }
        else {
            //console.log("ELSSSSSSSSSSSSSSSSSSSSSSSSSSSSSEEE");
            const sortOptionChainData = _.orderBy(expiryData, ["StrikeRate"], ["asc"]);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            const optionchainData = {
                sortOptionChainData: sortOptionChainData,
                lastrate: undefined,
            };
            resolve(optionchainData);
        }
    });
});
const getStrategyBuilderPayoffNewWithWorker = (symbol, daysToExpiry, expiry, minStrike, maxStrike, requestArray, cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        dashboardWorkerRef
            .GetStrategyBuilderPayoffNewImpl(symbol, daysToExpiry, expiry, minStrike, maxStrike, requestArray, cancelToken)
            .then((data) => {
            const { updateStrategyValue, masterChartData } = data;
            if (updateStrategyValue && masterChartData) {
                resolve(data);
            }
            else {
                reject(data);
            }
        });
    });
});
const getAllOptionChainExpiryListWithCaching = (symbol, exch, exchType, 
// expiry: string,
controllerId) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        let disableCache = false;
        if (remoteConfigData) {
            disableCache = remoteConfigData.disableExpiryCache;
        }
        const expiryData = getDataFromSession(SESSION_KEYS + symbol);
        if (!expiryData || disableCache) {
            dashboardWorkerRef
                .GetOptionchainListImpl(symbol, exch, exchType, controllerId)
                .then((result) => {
                var _a, _b, _c, _d, _e;
                //  console.log(result.data, "METHODS RESULT");
                if (result.data == "canceled") {
                    resolve({
                        filterList: [],
                        sortOptionChainData: [],
                        futExpiry: (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.FutExpiry,
                        lastrate: result === null || result === void 0 ? void 0 : result.data.Lastrate,
                        Status: "cancelled",
                    });
                }
                const expiryList = (_b = result.data) === null || _b === void 0 ? void 0 : _b.OptExpiry;
                const optionChainData = (_c = result.data) === null || _c === void 0 ? void 0 : _c.OptionChainList;
                if (result.data.Status == 0) {
                    const currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    let filterList = expiryList.filter((singleData) => {
                        const datetoMilli = convertToMillisfromDateString(singleData.ExpiryDate);
                        singleData.ExpiryDate = datetoMilli;
                        const millisString = getMillisFromDateString(datetoMilli);
                        return moment(millisString).isSameOrAfter(currentDate);
                    });
                    filterList = orderBy(filterList, ["ExpiryDate"]);
                    (_d = result.data) === null || _d === void 0 ? void 0 : _d.FutExpiry.map((expirylist) => {
                        expirylist.ExpiryDate = convertToMillisfromDateString(expirylist.ExpiryDate);
                    });
                    // resolve(filterList);
                    if (!disableCache) {
                        setDataInSession(SESSION_KEYS.FNO_EXPIRY + symbol, filterList, true);
                    }
                    const sortOptionChainData = _.orderBy(optionChainData, ["StrikeRate"], ["asc"]);
                    const optionchainData = {
                        filterList: filterList,
                        sortOptionChainData: sortOptionChainData,
                        futExpiry: (_e = result.data) === null || _e === void 0 ? void 0 : _e.FutExpiry,
                        lastrate: result.data.Lastrate,
                    };
                    resolve(optionchainData);
                    //resolve(sortOptionChainData);
                    if (!disableCache) {
                        setDataInSession(SESSION_KEYS.FNO_OPTIONS + symbol + "-", sortOptionChainData, true);
                    }
                }
                else {
                    const optionchainData = {
                        filterList: undefined,
                        sortOptionChainData: undefined,
                        futExpiry: undefined,
                        lastrate: undefined,
                    };
                    resolve(optionchainData);
                }
            })
                .catch((error) => {
                if (error.includes("Unserializable")) {
                    reject(false);
                }
                else {
                    reject();
                }
            });
        }
        else {
            const sortOptionChainData = _.orderBy(expiryData, ["StrikeRate"], ["asc"]);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            const localExpiryData = expiryData;
            const filterList = localExpiryData.filter((singleData) => {
                const datetoMilli = convertToMillisfromDateString(singleData.ExpiryDate);
                singleData.ExpiryDate = datetoMilli;
                const millisString = getMillisFromDateString(datetoMilli);
                return moment(millisString).isSameOrAfter(currentDate);
            });
            const optionchainData = {
                filterList: filterList,
                sortOptionChainData: sortOptionChainData,
                futExpiry: undefined,
                lastrate: undefined,
            };
            resolve(optionchainData);
            if (localExpiryData.length > filterList.length) {
                setDataInSession(SESSION_KEYS.FNO_EXPIRY + symbol, filterList, true);
            }
        }
    });
});
const getOptionsFromSymbolWithCaching = (symbol, expiry, exchange) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        let disableCache = false;
        if (remoteConfigData) {
            disableCache = remoteConfigData.disableOptionsCache;
        }
        // if (REACT_APP_ENV == "development") {
        //   const optionChainData = getOptionsDummyData().body.Options;
        //   const sortOptionChainData = _.orderBy(
        //     optionChainData,
        //     ["StrikeRate"],
        //     ["asc"]
        //   );
        //   resolve(sortOptionChainData);
        //   return;
        // }
        const expiryData = getDataFromSession(SESSION_KEYS.FNO_OPTIONS + symbol + "-" + expiry);
        if (!expiryData || disableCache) {
            getOptionsFromSymbol(symbol, expiry, exchange) // remove
                .then((result) => {
                const optionChainData = result.data.body.Options;
                const status = result.data.body.Status;
                // const optionChainData = getSensexOptionsDummyData().body.Options;
                // const status = getSensexOptionsDummyData().body.Status;
                if (status == 0) {
                    const sortOptionChainData = _.orderBy(optionChainData, ["StrikeRate"], ["asc"]);
                    resolve(sortOptionChainData);
                    if (!disableCache) {
                        setDataInSession(SESSION_KEYS.FNO_OPTIONS + symbol + "-" + expiry, sortOptionChainData, true);
                    }
                }
                else {
                    resolve([]);
                }
            })
                .catch(() => {
                reject();
            });
        }
        else {
            const sortOptionChainData = _.orderBy(expiryData, ["StrikeRate"], ["asc"]);
            resolve(sortOptionChainData);
        }
    });
});
const getOrderBookCaching = (isCachingValid) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        let disableCache = false;
        if (remoteConfigData) {
            disableCache = remoteConfigData.disableOrderBookCache;
        }
        const orderBookData = getDataFromSession(SESSION_KEYS.ORDERBOOK);
        if (isCachingValid && !disableCache && orderBookData) {
            resolve(orderBookData);
        }
        else {
            // if (REACT_APP_ENV == "development") {
            //   const resultfromorderbook: any = { data: getOrderBookDummyData() };
            //   setDataInSession(
            //     SESSION_KEYS.ORDERBOOK,
            //     resultfromorderbook.data.body.OrderBookDetail,
            //     true
            //   );
            //   return resultfromorderbook.data.body.OrderBookDetail;
            // }
            // getOrderBook()
            //   .then((result) => {
            //     if (result.data.body.Status == 0) {
            //       const orderBookData_API = result.data.body.OrderBookDetail;
            //       if (result.data.body.Status == 0) {
            //         setDataInSession(SESSION_KEYS.ORDERBOOK, orderBookData_API, true);
            //         resolve(orderBookData_API);
            //       } else {
            //         setDataInSession(SESSION_KEYS.ORDERBOOK, [], true);
            //         resolve([]);
            //       }
            //     } else {
            //       setDataInSession(SESSION_KEYS.ORDERBOOK, [], true);
            //       resolve([]);
            //     }
            //   })
            //   .catch(() => {
            //     // reject();
            //   });
        }
    });
});
function intComma(val, maxDecimal, minDecimal) {
    if (minDecimal == undefined) {
        if (maxDecimal != undefined) {
            minDecimal = maxDecimal;
        }
    }
    // console.log(val, minDecimal, maxDecimal, " val,min,max");
    const value = Number(val).toLocaleString("en-IN", {
        minimumFractionDigits: minDecimal == undefined ? 2 : minDecimal,
        maximumFractionDigits: maxDecimal == undefined ? 2 : maxDecimal,
    });
    if (value === "NaN")
        return "-";
    else
        return value;
    // return value;
}
function intCommaWithoutDecimal(val) {
    const value = Number(val).toLocaleString("en-IN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    if (value === "NaN")
        return "-";
    else
        return value;
    // return value;
}
const displayDigits = (exchType, val) => {
    if (val == undefined) {
        return "";
    }
    else {
        if (exchType == "U") {
            return intComma(val, 4, 4);
        }
        else {
            return intComma(val, 2, 2);
        }
    }
};
const filterUserWatchList = (data) => {
    return data.filter((singleItem) => {
        if (singleItem.CanEditOrDelete) {
            return singleItem;
        }
    });
};
const convertNumberToShortText = (data) => {
    let returnValue = "";
    const newData = Math.abs(data);
    if (checkIsEmpty(data)) {
    }
    else if (newData >= 10000000) {
        returnValue = (data / 10000000).toFixed(2) + " Cr";
    }
    else if (newData >= 100000) {
        returnValue = (data / 100000).toFixed(2) + " L";
    }
    else if (newData >= 1000) {
        returnValue = (data / 1000).toFixed(2) + " K";
    }
    else {
        returnValue = intComma(data, 2, 2);
    }
    return returnValue;
};
const getChangeAndChangePercentageWithoutSign = (currentOI, prevOI) => {
    let oiChange = "0";
    if (!prevOI) {
        oiChange = `${currentOI}`;
    }
    else if (!currentOI) {
        oiChange = `${prevOI}`;
    }
    else {
        oiChange = `${currentOI - prevOI}`;
    }
    return oiChange;
};
const getChangeAndChangePercentage = (latestRate, previousClose) => {
    if (latestRate == undefined && previousClose == undefined) {
        return {
            differenceValue: "0",
            differencePercentage: "0%",
            differencePercentageValue: 0,
            isNegative: false,
        };
    }
    else if (latestRate == undefined) {
        return {
            differenceValue: previousClose + "",
            differencePercentage: "0%",
            differencePercentageValue: 0,
            isNegative: false,
        };
    }
    else if (previousClose == undefined) {
        return {
            differenceValue: latestRate + "",
            differencePercentage: "0%",
            differencePercentageValue: 0,
            isNegative: false,
        };
    }
    const differenceValue = latestRate - previousClose;
    const differencePercentage = (differenceValue * 100) / previousClose;
    const isNegative = differenceValue < 0;
    const differenceValueString = previousClose != 0
        ? (isNegative ? "" : "+") + differenceValue.toFixed(2)
        : "0";
    const differencePercentageString = previousClose != 0
        ? (isNegative ? "" : "+") + differencePercentage.toFixed(2) + "%"
        : "0";
    return {
        differenceValue: differenceValueString,
        differencePercentage: differencePercentageString,
        isNegative,
        differencePercentageValue: differencePercentage,
    };
};
export const getOiChangePercentage = (currentOI, prevOI) => {
    let oiChange = "0";
    if (!prevOI) {
        oiChange = `${currentOI}`;
    }
    else if (!currentOI) {
        oiChange = `${prevOI}`;
    }
    else {
        oiChange = (((currentOI - prevOI) * 100) / prevOI).toFixed(2);
    }
    return oiChange;
};
const handleDecimalLimit = (valueString, lengthAllowed) => {
    if (isEmpty(valueString)) {
        //DO nothing for now
    }
    else {
        const split = valueString.split(".");
        //console.log(split);
        if (split.length > 1) {
            const lengthOfDecimal = split[1].length;
            if (lengthOfDecimal > lengthAllowed) {
                valueString =
                    parseInt(split[0]) + "." + split[1].substring(0, lengthAllowed);
            }
        }
        else {
            return valueString + "";
        }
    }
    // console.log(valueString);
    return valueString;
};
const getSearchFilteredData = (arrayData, keyName, searchQuery) => {
    let filteredData = arrayData;
    if (!isEmpty(searchQuery)) {
        searchQuery.split(" ").forEach((singleToken) => {
            filteredData = filteredData.filter((el) => el[keyName].toUpperCase().indexOf(singleToken) > -1);
        });
    }
    return filteredData;
};
const getExchFromDisplayText = (displayString) => {
    if (displayString == "NSE") {
        return "N";
    }
    else if (displayString == "NFO") {
        return "N";
    }
    else if (displayString == "BSE") {
        return "B";
    }
    else if (displayString == "MCX") {
        return "M";
    }
    else {
        return displayString;
    }
};
const getDisplayTextFromExchangeChart = (exchange, exchangeType) => {
    // if (exchangeType == "U") {
    //   return "CURR";
    // } else
    // } else
    if (exchange == "N") {
        return "NSE";
    }
    else if (exchange == "B") {
        return "BSE";
    }
    else if (exchange == "M") {
        return "M";
    }
    else {
        return exchange;
    }
};
const isMultiple = (initialTriggerPrice, tickSize) => {
    if (isNaN(tickSize) || tickSize === 0) {
        return false;
    }
    const checkTemp = initialTriggerPrice % tickSize;
    const latestCheck = Math.round(checkTemp * Math.pow(10, countDecimals(tickSize))) /
        Math.pow(10, countDecimals(tickSize));
    // Check if trigger price is a multiple of tick size
    return latestCheck === tickSize || latestCheck === 0;
};
const countDecimals = (num) => {
    if (Math.floor(num) === num)
        return 0;
    const str = num.toString();
    if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
        return parseInt(str.split("-")[1]) || 0;
    }
    else if (str.indexOf(".") !== -1) {
        return str.split(".")[1].length || 0;
    }
    return parseInt(str.split("-")[1]) || 0;
};
const getDisplayTextFromExchange = (exchange, exchangeType, isChartView) => {
    if (exchangeType == "U") {
        return "CURR";
    }
    else if (exchange == "N") {
        if (exchangeType == "C") {
            return "NSE";
        }
        else {
            return "NFO";
        }
    }
    else if (exchange == "B") {
        if (exchangeType == "C") {
            return "BSE";
        }
        else {
            return "BFO";
        }
    }
    else if (exchange == "M") {
        if (isChartView) {
            return "M";
        }
        else {
            return "MCX";
        }
    }
    else {
        return exchange;
    }
};
const onRenderCallback = (id, // the "id" prop of the Profiler tree that has just committed
phase, // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
actualDuration, // time spent rendering the committed update
baseDuration, // estimated time to render the entire subtree without memoization
startTime, // when React began rendering this update
commitTime, // when React committed this update
interactions // the Set of interactions belonging to this update
) => {
    if (REACT_APP_ENV === "development") {
        // console.log(`id = ${id} , phase: ${phase}, actualDuration: ${actualDuration}, baseDuration: ${baseDuration}
        // startTime: ${startTime} commitTime: ${commitTime}, interactions: ${JSON.stringify(
        //   interactions
        // )}
        // `);
    }
    // Aggregate or log render timings...
};
const getOrderValidityFromDayType = (dayType) => {
    let orderValidity = 0;
    if (dayType == "day") {
        orderValidity = 0;
    }
    else if (dayType == "gtd") {
        orderValidity = 1;
    }
    else if (dayType == "gtc") {
        orderValidity = 2;
    }
    else if (dayType == "ioc") {
        orderValidity = 3;
    }
    else if (dayType == "eos") {
        orderValidity = 4;
    }
    else if (dayType == "vtd") {
        orderValidity = 5;
    }
    else if (dayType == "fok") {
        orderValidity = 6;
    }
    return orderValidity;
};
function epochToDate(epoch) {
    // Assuming epoch is in seconds, convert it to milliseconds
    var date = new Date(epoch * 1000);
    // Get day and month
    var day = date.getDate();
    var month = date.toLocaleString("default", { month: "short" }).toUpperCase(); // Short month name like "Jan", "Feb", etc.
    var year = date.getFullYear().toString().slice(-2); // Last two digits of the year
    // Format the date string as "dd month'yy"
    var formattedDate = `${day} ${month}'${year}`;
    return formattedDate;
}
const getDefaultDateFormat = (date) => {
    return getFormattedDate(date, DATE_FORMAT);
};
const getFormattedDate = (date, dateFormat) => {
    if (date) {
        // date = date.replace("'", "");
        const date_temp = moment(date);
        if (date_temp.isValid()) {
            return date_temp.format(dateFormat).toUpperCase();
        }
        else {
            return date;
        }
    }
    else {
        return date;
    }
};
const getMillisFromDateString = (dateString) => {
    const splitString = dateString.split("(");
    const timeString = splitString[1].split("+")[0];
    return Number(timeString);
};
const convertToMillisfromDateString = (dateString) => {
    const timeString = "/Date(" + moment(dateString).valueOf() + "+0000)/";
    return timeString;
};
const currencyDecimal = (val) => {
    const value = (+val).toFixed(4); // + => Number ₹
    //value ?? "-";
    if (isNaN(val))
        return "-";
    else
        return value;
    //return value;
};
const getExhangeColor = (value) => {
    let colorCode = "";
    switch (value) {
        case "NFO":
            colorCode = "NSE";
            break;
        case "NSE":
            colorCode = "NSE";
            break;
        case "BFO":
            colorCode = "BSE";
            break;
        case "BSE":
            colorCode = "BSE";
            break;
        case "MCX":
            colorCode = "greyBgTag";
            break;
        case "CURR":
            colorCode = "greyBgTag";
            break;
        default:
            colorCode = "default";
    }
    return colorCode;
};
const getExhangeTypeColor = (value) => {
    let colorCode = "";
    switch (value) {
        case "CALL":
        case "CE":
            colorCode = "positiveText";
            break;
        case "PUT":
        case "PE":
            colorCode = "negativeText";
            break;
        case "FUT":
            colorCode = "futText";
            break;
        case "C":
        case "CASH":
            colorCode = "CASH";
            break;
        default:
            colorCode = "default";
    }
    return colorCode;
};
const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    // textArea.style.display = "none";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        const successful = document.execCommand("copy");
        const msg = successful ? "successful" : "unsuccessful";
    }
    catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
};
const copyTextToClipboard = (text) => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        // console.log("Async: Copying to clipboard was successful!");
    }, function (err) {
        console.error("Async: Could not copy text: ", err);
    });
};
const redirectToCDSL = (postUrl, dpId, requestId, transDtls, pledgeFlag) => {
    try {
        const form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", postUrl); //data.body.PostURL
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "DPId");
        hiddenField.setAttribute("value", dpId);
        form.appendChild(hiddenField);
        const hiddenField1 = document.createElement("input");
        hiddenField1.setAttribute("type", "hidden");
        hiddenField1.setAttribute("name", "ReqId");
        hiddenField1.setAttribute("value", requestId);
        form.appendChild(hiddenField1);
        const hiddenField2 = document.createElement("input");
        hiddenField2.setAttribute("type", "hidden");
        hiddenField2.setAttribute("name", "Version");
        hiddenField2.setAttribute("value", "1.0");
        form.appendChild(hiddenField2);
        const hiddenField3 = document.createElement("input");
        hiddenField3.setAttribute("type", "hidden");
        if (pledgeFlag) {
            hiddenField3.setAttribute("name", "pledgeDtls");
        }
        else {
            hiddenField3.setAttribute("name", "TransDtls");
        }
        hiddenField3.setAttribute("value", transDtls);
        form.appendChild(hiddenField3);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
    catch (e) {
        console.error(e);
    }
};
const getBuySellFromPostionItem = (item, filterType) => {
    let returnValue = "";
    const netQty = filterType == "day" ? item.BuyQty - item.SellQty : item.NetQty;
    if (netQty == 0) {
        returnValue = "CLOSED";
    }
    else if (netQty > 0) {
        returnValue = "BUY";
    }
    else {
        returnValue = "SELL";
    }
    return returnValue;
};
const calculateDayAveragePrice = (item) => {
    // if(data && data.length>0){
    //    data.forEach( (item) =>{
    let avgRateOne = 0;
    avgRateOne = item.AvgRate;
    const netQty = item.BuyQty - item.SellQty;
    if (netQty == 0) {
        avgRateOne = 0;
    }
    else if (netQty > 0) {
        avgRateOne = item.BuyAvgRate;
    }
    else if (netQty < 0) {
        avgRateOne = item.SellAvgRate;
    }
    else {
        avgRateOne = item.BuyAvgRate;
    }
    return avgRateOne;
    //  });
    // }
};
const calculateNetQuantity = (item, filter) => {
    let netQty = 0;
    if (filter == "day") {
        netQty = item.BuyQty - item.SellQty;
    }
    else {
        netQty = item.NetQty;
    }
    return netQty;
};
const plCalculation = (positionDataValue) => {
    return plCalculation_simple(positionDataValue.BuySell, positionDataValue.BookedPL, positionDataValue.LTP, positionDataValue.Avg, positionDataValue.NetQty, positionDataValue.Multiplier);
    // let calValue;
    // if (positionDataValue.BuySell == "CLOSED") {
    //   calValue = positionDataValue.BookedPL;
    // } else {
    //   calValue =
    //     (positionDataValue.LTP - positionDataValue.Avg) *
    //     positionDataValue.NetQty *
    //     positionDataValue.Multiplier;
    // }
    // return calValue;
};
const plCalculation_simple = (BuySell, BookedPL, LTP, Avg, NetQty, Multiplier) => {
    let calValue;
    if (BuySell == "CLOSED") {
        calValue = BookedPL;
    }
    else {
        calValue = (LTP - Avg) * NetQty * Multiplier;
    }
    return calValue;
};
const calculateAveragePriceAsPerFilter = (item, filter) => {
    if (filter == "day") {
        return calculateDayAveragePrice(item);
    }
    else {
        return calculateAveragePrice(item);
    }
};
const calculateAveragePrice = (item) => {
    // if(data && data.length>0){
    //    data.forEach( (item) =>{
    let avgRateOne = 0;
    avgRateOne = item.AvgRate;
    if (item.NetQty == 0) {
        avgRateOne = 0;
    }
    else if (item.NetQty > 0) {
        if (item.CFQty > 0) {
            const holdingPrice = Math.abs(item.CFQty) * item.AvgCFQty;
            const buyValue = Math.abs(item.BuyQty) * item.BuyAvgRate;
            avgRateOne =
                (buyValue + holdingPrice) /
                    (Math.abs(item.BuyQty) + Math.abs(item.CFQty));
        }
        else {
            avgRateOne = item.BuyAvgRate;
        }
    }
    else if (item.NetQty < 0) {
        if (item.CFQty < 0) {
            const holdingPrice = Math.abs(item.CFQty) * item.AvgCFQty;
            const sellValue = Math.abs(item.SellQty) * item.SellAvgRate;
            avgRateOne =
                (sellValue + holdingPrice) /
                    (Math.abs(item.SellQty) + Math.abs(item.CFQty));
        }
        else {
            avgRateOne = item.SellAvgRate;
        }
    }
    else {
        avgRateOne = item.BuyAvgRate;
    }
    return avgRateOne;
    //  });
    // }
};
const calculateSellAveragePrice = (item) => {
    if (item.NetQty == 0) {
        item.AvgRate = 0;
    }
    else if (item.NetQty < 0) {
        const holdingPrice = Math.abs(item.CFQty) * item.AvgCFQty;
        const sellValue = Math.abs(item.SellQty) * item.SellAvgRate;
        item.AvgRate =
            (sellValue + holdingPrice) /
                (Math.abs(item.SellQty) + Math.abs(item.CFQty));
    }
    else {
        item.AvgRate = item.SellAvgRate;
    }
    return Math.abs(item.AvgRate);
};
const getBookedPl = (item) => {
    let BookedPL = 0;
    if (item.NetQty == 0) {
        const holdingValue = item.CFQty * item.AvgCFQty;
        BookedPL = item.SellValue - item.BuyValue - holdingValue;
    }
    return BookedPL;
};
const getUnrealizedPL = (_ltp, item) => {
    let MTM = 0;
    try {
        // If netQty=0, then MTM will be 0
        if (item.NetQty == 0) {
            return 0;
        }
        if (item.NetQty > 0) {
            //BUY Case
            if (item.CFQty > 0) {
                const holdingValue = Math.abs(item.CFQty) * item.AvgCFQty;
                const buyValue = Math.abs(item.BuyQty) * item.BuyAvgRate;
                const avgBuyRate = (buyValue + holdingValue) /
                    (Math.abs(item.BuyQty) + Math.abs(item.CFQty));
                MTM = Math.abs(item.NetQty) * (_ltp - avgBuyRate);
            }
            else {
                MTM = Math.abs(item.NetQty) * (_ltp - item.BuyAvgRate);
            }
        }
        else {
            //SELL Case
            if (item.CFQty < 0) {
                const holdingValue = Math.abs(item.CFQty) * item.AvgCFQty;
                const sellValue = Math.abs(item.SellQty) * item.SellAvgRate;
                const avgSellRate = (sellValue + holdingValue) /
                    (Math.abs(item.SellQty) + Math.abs(item.CFQty));
                MTM = Math.abs(item.NetQty) * (avgSellRate - _ltp);
            }
            else {
                MTM = Math.abs(item.NetQty) * (item.SellAvgRate - _ltp);
            }
        }
        //Multiply Multiplier
        MTM = MTM * item.Multiplier;
    }
    catch (error) {
        console.error(error);
    }
    finally {
    }
    return MTM;
};
const getNearestExpiryElement = (inputArray, scripName) => {
    let nearestFutureDataTemp;
    inputArray.forEach((singleElement) => {
        let timeInMillis = new Date().getTime();
        let splitString = singleElement.Expiry.split("(");
        const timeString = splitString[1].split("+")[0];
        if (parseFloat(timeString) > timeInMillis &&
            singleElement.Name == scripName) {
            if (nearestFutureDataTemp) {
                timeInMillis = new Date().getTime();
                splitString = nearestFutureDataTemp.Expiry.split("(");
                const oldTimeString = splitString[1].split("+")[0];
                if (parseFloat(oldTimeString) > parseFloat(timeString)) {
                    nearestFutureDataTemp = singleElement;
                }
            }
            else {
                nearestFutureDataTemp = singleElement;
            }
        }
    });
    const nearestFutureData = nearestFutureDataTemp
        ? nearestFutureDataTemp
        : inputArray[0];
    return nearestFutureData;
};
const getBase64EncryptedText = (inputValue) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(inputValue));
};
const getBase64DecryptedAccessList = (encryptedValue) => {
    const decodedUtf8String = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(encryptedValue));
    return JSON.parse(decodedUtf8String);
};
const openChartTab = (inputValue) => {
    try {
        if (REACT_APP_ENV == "production") {
            window.open(`https://charts.5paisa.com${NavPaths.Chart}?fullName=${inputValue.fullName.includes("&")
                ? inputValue.fullName.split("&").join("%26")
                : inputValue.fullName}&source=derivative&exchange=${inputValue.exchange}&exchangeType=${inputValue.exchangeType}&expiry=${inputValue.expiry}&symbol=${inputValue.symbol}&strikePrice=${inputValue.strikePrice}&scripCode=${inputValue.scripCode}&theme=${getDataFromSession(SESSION_KEYS.THEME)}`);
        }
        else {
            window.open(`${NavPaths.Chart}?fullName=${inputValue.fullName.includes("&")
                ? inputValue.fullName.split("&").join("%26")
                : inputValue.fullName}&source=derivative&exchange=${inputValue.exchange}&exchangeType=${inputValue.exchangeType}&expiry=${inputValue.expiry}&symbol=${inputValue.symbol}&strikePrice=${inputValue.strikePrice}&scripCode=${inputValue.scripCode}&theme=${getDataFromSession(SESSION_KEYS.THEME)}`);
        }
    }
    catch (err) {
        console.error(err);
    }
};
const getChartUrl = (inputValue, baseUrl, searchFlag = false) => {
    const scripTypeObj = getSegmentAndProductType(inputValue.fullName, inputValue.exchange, inputValue.exchangeType);
    let typeValue = "";
    // if (inputValue.fullName.includes("CRUDE")) {
    //   // console.log(inputValue);
    //   // console.log(scripTypeObj);
    // }
    if (scripTypeObj.segmentType == EQUITY_SEGMENT) {
        if (scripTypeObj.productType == CASH_PRODUCT) {
            typeValue = "overview";
        }
        else if (scripTypeObj.productType == FUTURES_PRODUCT) {
            typeValue = "futures";
        }
        else if (scripTypeObj.productType == OPTIONS_PRODUCT) {
            typeValue = "options";
        }
    }
    else if (scripTypeObj.segmentType == COMMODITY_SEGMENT) {
        typeValue = "future-curcom";
        inputValue.exchange = "M";
    }
    else if (scripTypeObj.segmentType == CURRENCY_SEGMENT) {
        typeValue = "future-curcom";
    }
    let url = baseUrl +
        "source=derivative&range=D&period=1&appName=5paisa&appVer=5.11.6.0&osName=TTWEB&" +
        "loginId=" +
        getDataFromSession(SESSION_KEYS.CLIENT_CODE) +
        `&type=${typeValue}` +
        `&exchange=${getDisplayTextFromExchangeChart(inputValue.exchange, inputValue.exchangeType)}&exchType=${inputValue.exchangeType}` +
        `&symbol=${inputValue.symbol.trim()}&scripCode=${inputValue.scripCode}`;
    if (scripTypeObj.productType == OPTIONS_PRODUCT) {
        url +=
            `&option_type=${scripTypeObj.subProductType == CALL_OPTION_TYPE ? "CE" : "PE"}&strike_price=${inputValue.strikePrice}` +
                `&expiry_date=${inputValue.expiry}`;
    }
    else if (scripTypeObj.productType == FUTURES_PRODUCT) {
        url +=
            `&expiry_date=${inputValue.expiry}` +
                `&exch=${getDisplayTextFromExchangeChart(inputValue.exchange, inputValue.exchangeType)}`;
    }
    url += `&searchFlag=true&theme=${inputValue.theme}`;
    return url;
};
const getStockInfoChart = (inputValue, baseUrl, searchFlag = false) => {
    const scripTypeObj = getSegmentAndProductType(inputValue.fullName, inputValue.exchange, inputValue.exchangeType);
    let typeValue = "";
    // if (inputValue.fullName.includes("CRUDE")) {
    //   // console.log(inputValue);
    //   // console.log(scripTypeObj);
    // }
    if (scripTypeObj.segmentType == EQUITY_SEGMENT) {
        if (scripTypeObj.productType == CASH_PRODUCT) {
            typeValue = "overview";
        }
        else if (scripTypeObj.productType == FUTURES_PRODUCT) {
            typeValue = "futures";
        }
        else if (scripTypeObj.productType == OPTIONS_PRODUCT) {
            typeValue = "options";
        }
    }
    else if (scripTypeObj.segmentType == COMMODITY_SEGMENT) {
        typeValue = "future-curcom";
        inputValue.exchange = "M";
    }
    else if (scripTypeObj.segmentType == CURRENCY_SEGMENT) {
        typeValue = "future-curcom";
    }
    let url = baseUrl +
        "range=D&period=1&appName=5paisa&appVer=5.11.6.0&osName=TTWEB&" +
        "loginId=" +
        getDataFromSession(SESSION_KEYS.CLIENT_CODE) +
        `&type=${typeValue}` +
        `&exchange=${getDisplayTextFromExchangeChart(inputValue.exchange, inputValue.exchangeType)}&exchType=${inputValue.exchangeType}` +
        `&symbol=${inputValue.symbol.trim()}&scripCode=${inputValue.scripCode}`;
    if (scripTypeObj.productType == OPTIONS_PRODUCT) {
        url +=
            `&option_type=${scripTypeObj.subProductType == CALL_OPTION_TYPE ? "CE" : "PE"}&strike_price=${inputValue.strikePrice}` +
                `&expiry_date=${inputValue.expiry}`;
    }
    else if (scripTypeObj.productType == FUTURES_PRODUCT) {
        url +=
            `&expiry_date=${inputValue.expiry}` +
                `&exch=${getDisplayTextFromExchangeChart(inputValue.exchange, inputValue.exchangeType)}`;
    }
    url += `&searchFlag=false&theme=${inputValue.theme}`;
    return url;
};
const getStartOfTheDayTime = () => {
    return moment()
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .set("millisecond", 0)
        .valueOf();
};
const getAfterMarketHours = (marketStatusList, exchange, exchangeType) => {
    const afterMarketHoursObj = marketStatusList.find((singleElement) => {
        return (singleElement.Exch == exchange && singleElement.ExchType == exchangeType);
    });
    const afterMarketHours = afterMarketHoursObj
        ? afterMarketHoursObj.MarketStatus.toLowerCase() == "closed"
            ? "Y"
            : "N"
        : "N";
    return afterMarketHours;
};
const getToken = (clientCode, length) => {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    const outputData = CryptoJS.MD5(String(clientCode + new Date().getTime() + result));
    return outputData.toString();
};
const getEnvironmentVariableOrEmpty = (envVariable) => {
    if (envVariable) {
        return envVariable;
    }
    else {
        return "";
    }
};
const getStatusForOrderData = (value, props) => {
    let isPending = false;
    let statusText = "";
    let statusCSS = "";
    if (value.includes("Fully Executed")) {
        statusText = "Fully Executed";
        statusCSS = `spanForExecuted me-2`;
    }
    else if (value.includes("Rejected By 5P")) {
        statusText = "Rejected";
        statusCSS = `spanForRejected me-2`;
    }
    else if (value.includes("Cancelled")) {
        statusText = "Cancelled";
        statusCSS = `spanForCancelled me-2`;
    }
    else if (value.includes("SL Triggered")) {
        statusText = "SL Triggered";
        statusCSS = `spanForPending me-2`;
        isPending = true;
    }
    else if (value.includes("Pending")) {
        statusText = "Pending";
        statusCSS = `spanForPending me-2`;
        isPending = true;
    }
    else if (value.includes("Partly Executed")) {
        statusText = "Partly Executed";
        statusCSS = `spanForPending me-2`;
        isPending = true;
    }
    else if (value.includes("AH Placed")) {
        statusText = "AH Placed";
        statusCSS = `spanForPending me-2`;
        isPending = true;
    }
    else if (value.includes("Placed")) {
        statusText = "Placed";
        statusCSS = `spanForPlaced me-2`;
    }
    else if (value.includes("Rejected by Exch")) {
        statusText = "Rejected";
        statusCSS = `spanForRejected me-2`;
    }
    else if (value.includes("Waiting in Q on Exch Link")) {
        statusText = "Waiting in Q";
        statusCSS = `spanForWaiting me-2`;
    }
    else if (value.includes("Sent to Exch")) {
        statusText = "Sent to Exch";
        statusCSS = `spanForPending me-2`;
    }
    else if (value.includes("Modified")) {
        statusText = "Modified";
        statusCSS = `spanForModified me-2`;
        isPending = true;
    }
    else {
        statusText = value;
        statusCSS = `spanForPending me-2`;
    }
    if (props.PendingQty == 0) {
        isPending = false;
    }
    let isCancelVisible = isPending;
    let isReorderVisible = true;
    if (isCancelVisible) {
        if (props.DelvIntra == "S") {
            if (props.SMOProfitRate != 0 && props.SMOSLTriggerRate != 0) {
                // orderFor = "BRACKET INITIAL";
            }
            else if (props.WithSL == "Y") {
                // orderFor = "BRACKET SL";
                // return Constants.ORDERTYPE.BRACKET_SL;
                isCancelVisible = false;
                isReorderVisible = false;
            }
            else if (props.WithSL == "N") {
                isCancelVisible = false;
                isReorderVisible = false;
                // orderFor = "BRACKET PROFIT";
                // return Constants.ORDERTYPE.BRACKET_PROFIT;
            }
        }
        else if (props.DelvIntra == "C") {
            if (props.SMOSLTriggerRate != 0) {
                // orderFor = "COVER_INITIAL";
            }
            else if (props.WithSL == "Y") {
                // orderFor = "BRACKET SL";
                // return Constants.ORDERTYPE.COVER_SL;
                isCancelVisible = false;
                isReorderVisible = false;
            }
        }
    }
    if (props.isCancelVisible !== isCancelVisible && props.setCancelVisible) {
        props.setCancelVisible(isCancelVisible);
    }
    return {
        statusText,
        statusCSS,
        isModifyVisible: isPending,
        isCancelVisible,
        isReorderVisible,
    };
};
const getOrderFor = (DelvIntra) => {
    let orderFor = "";
    if (DelvIntra == "D") {
        orderFor = "DEL";
    }
    else if (DelvIntra == "I") {
        orderFor = "INT";
    }
    else if (DelvIntra == "C") {
        orderFor = "COVER";
        // if (props.SMOProfitRate != 0 && props.SMOSLTriggerRate != 0) {
        //   orderFor = "COVER INITIAL";
        // } else if (props.WithSL == "Y") {
        //   orderFor = "COVER SL";
        //   // return Constants.ORDERTYPE.BRACKET_SL;
        // }
    }
    else if (DelvIntra == "S") {
        orderFor = "BRACKET";
        // if (props.SMOProfitRate != 0 && props.SMOSLTriggerRate != 0) {
        //   orderFor = "BRACKET INITIAL";
        // } else if (props.WithSL == "Y") {
        //   orderFor = "BRACKET SL";
        //   // return Constants.ORDERTYPE.BRACKET_SL;
        // } else if (props.WithSL == "N") {
        //   orderFor = "BRACKET PROFIT";
        //   // return Constants.ORDERTYPE.BRACKET_PROFIT;
        // }
    }
    return orderFor;
};
const getOrderType = (props) => {
    let OrderType = "";
    if ((props.DelvIntra == "D" || props.DelvIntra == "I") &&
        props.WithSL == "N") {
        OrderType = "RL";
    }
    else if ((props.DelvIntra == "D" ||
        props.DelvIntra == "I" ||
        props.DelvIntra == "C" ||
        props.DelvIntra == "S") &&
        props.WithSL == "Y") {
        OrderType = "SL";
    }
    return OrderType;
};
const nearestNumberRoundOff = (value) => {
    value = value * 100;
    value = Math.trunc(value / 5);
    value = value * 5;
    value = (value / 100).toFixed(2);
    return value;
};
const getStockNameFromSearchData = (singleScript) => {
    let stockType = "FUT";
    let stockName;
    const splitName = singleScript.Name.split(" ");
    if (splitName.length > 1) {
        singleScript.Name = splitName[0];
    }
    if (singleScript.CPTypeText == "PUT") {
        stockType = "PE";
        // NIFTY 30 Jun 2022 CE 19100.00
        stockName =
            singleScript.Name +
                " " +
                getDefaultDateFormat(singleScript.ExpiryDate) +
                " PE " +
                singleScript.StrikeRate;
    }
    else if (singleScript.CPTypeText == "CALL") {
        stockType = "CE";
        stockName =
            singleScript.Name +
                " " +
                getDefaultDateFormat(singleScript.ExpiryDate) +
                " CE " +
                singleScript.StrikeRate;
    }
    else if (singleScript.ExchType == "C") {
        stockType = "CASH";
        stockName = singleScript.Name;
    }
    else {
        stockType = "FUT";
        stockName =
            singleScript.Name +
                " FUT " +
                getDefaultDateFormat(singleScript.ExpiryDate);
    }
    return stockName;
};
const getFormattedNameFromNameBreakup = (nameBreakup) => {
    let stockName = nameBreakup.name;
    if (nameBreakup.expiry) {
        if (!nameBreakup.scripType) {
            stockName += " " + "FUT";
        }
        stockName += " " + getDefaultDateFormat(nameBreakup.expiry);
    }
    if (nameBreakup.scripType) {
        stockName += " " + nameBreakup.scripType;
    }
    if (nameBreakup.strikeRate) {
        stockName += " " + nameBreakup.strikeRate;
    }
    return stockName;
};
const getFormattedNameFromString = (fullName) => {
    return getFormattedNameFromNameBreakup(splitAndGetDetailsFromLongName(fullName));
};
const getStatusColor = (status) => {
    let statusClass = "text-uppercase small ms-2";
    if (status == "Target Achieved" || status == "Revised Target Achieved") {
        statusClass = "buyBgTag buyBgTagLg text-uppercase small ms-2";
    }
    else if (status == "Stoploss Triggered" ||
        status == "Revised Stoploss Triggered" ||
        status == "Stop loss triggered" ||
        status == "Exit") {
        statusClass = "sellBgTag sellBgTagLg text-uppercase small ms-2";
    }
    else if (status == "Entry Pending") {
        statusClass = "orangeBgTag text-uppercase small ms-2";
    }
    else if (status == "Entry triggered") {
        statusClass = "blueBgTag text-uppercase small ms-2";
    }
    else if (status == "Profit Booked") {
        statusClass = "buyBgTag text-uppercase small ms-2";
    }
    return statusClass;
};
const getBasketAdvisoryClosedAtValue = (status, stopLoss, exitPrice) => {
    let returnValue = "0";
    const statusForStopLoss = [
        "Stoploss Triggered",
        "Revised Stoploss Triggered",
        "Stop loss triggered",
        "Exit",
    ];
    const statusForExitPrice = [
        "Target Achieved",
        "Revised Target Achieved",
        "Profit Booked",
    ];
    if (statusForStopLoss.includes(status)) {
        returnValue = stopLoss.toString();
    }
    else if (statusForExitPrice.includes(status)) {
        returnValue = exitPrice.toString();
    }
    return intComma(returnValue);
};
const parseSearchstring = (searchQuery) => {
    searchQuery = searchQuery.trim();
    let searchString = "";
    const splitSearchQuery = searchQuery.split(" ");
    for (let i = 0; i < splitSearchQuery.length; i++) {
        if (i !== splitSearchQuery.length - 1) {
            searchString = searchString + splitSearchQuery[i] + "* +";
        }
        else if (i === splitSearchQuery.length - 1) {
            searchString = searchString + splitSearchQuery[i] + "*";
        }
    }
    searchString = searchString.split("&").join("+&+");
    return searchString;
};
const convertNumberIntoLakhsAndCroreWithSign = (data) => {
    if (data == undefined) {
        return "-";
    }
    const newData = Math.abs(data);
    let returnValue = "";
    if (newData >= 10000000) {
        returnValue = (data / 10000000).toFixed(2) + " Cr";
    }
    else if (newData >= 100000) {
        returnValue = (data / 100000).toFixed(2) + " L";
    }
    else if (newData >= 1000) {
        returnValue = (data / 1000).toFixed(2) + " K";
    }
    else {
        returnValue = intComma(data, 2, 2);
    }
    return returnValue;
};
const splitSrikeBySpace = (value) => {
    const digitwithComma = intComma(value.match(/\d+/g), 0);
    // let tempValue = value.match(/[a-zA-Z]+|[0-9]+/g);
    // tempValue = tempValue.join(" ");
    const exchString = value.match(/[a-zA-Z]+/g);
    const tempValue = digitwithComma + " " + exchString;
    return tempValue;
};
const getStrike = (value) => {
    const strike = value.match(/\d+/g);
    return strike;
};
// const getStrategyData = (): Record<
//   string,
//   Record<string, string | boolean>[]
// > => {
//   return STRATEGY_DATA;
// };
const getPreferences = (clientCode) => {
    const myPreferences = getDataFromSession(SESSION_KEYS.PREFERENCE);
    // console.log(clientCode, "+++++++++");
    if (myPreferences === null || myPreferences === undefined) {
        //store get value  from getPreferences()
        const prefData = PREFERENCE_DATA;
        // getPreferenceAPI(clientCode).then((data) => {
        //   console.log(data);
        //   if (data) {
        //     console.log(data, "*******************************");
        //     prefData = data;
        //   }
        // });
        return prefData;
    }
    else {
        const parsedData = myPreferences;
        if (myPreferences.buyform == undefined) {
            parsedData.buyform = PREFERENCE_DATA.buyform;
        }
        if (myPreferences.orderSettings == undefined) {
            parsedData.orderSettings = PREFERENCE_DATA.orderSettings;
        }
        if (myPreferences.profile == undefined) {
            parsedData.profile = PREFERENCE_DATA.profile;
        }
        if (parsedData.straddlestrangle == undefined) {
            parsedData.straddlestrangle = PREFERENCE_DATA.straddlestrangle;
        }
        if (parsedData.reportHeightData == undefined ||
            parsedData.reportHeightData.LEFT == undefined) {
            parsedData.reportHeightData = PREFERENCE_DATA.reportHeightData;
        }
        if (parsedData.search == undefined ||
            parsedData.search.selectedScrip == undefined) {
            parsedData.search = PREFERENCE_DATA.search;
        }
        if (parsedData.watchlist == undefined) {
            parsedData.watchlist = PREFERENCE_DATA.watchlist;
        }
        else {
            if (parsedData.watchlist.selectedSort == undefined ||
                parsedData.watchlist.heatmap == undefined ||
                parsedData.watchlist.lastSavedView == undefined) {
                parsedData.watchlist = PREFERENCE_DATA.watchlist;
            }
        }
        if (parsedData.reports == undefined) {
            parsedData.reports = PREFERENCE_DATA.reports;
        }
        else if (parsedData.reports.position == undefined) {
            parsedData.reports.position = PREFERENCE_DATA.reports.position;
        }
        else if (parsedData.reports.orders == undefined) {
            parsedData.reports.orders = PREFERENCE_DATA.reports.orders;
        }
        if (parsedData.dashboard == undefined) {
            parsedData.dashboard = PREFERENCE_DATA.dashboard;
        }
        else {
            if (parsedData.dashboard.miniOC == undefined) {
                parsedData.dashboard.miniOC = PREFERENCE_DATA.dashboard.miniOC;
            }
            if (parsedData.dashboard.overview == undefined) {
                parsedData.dashboard.overview = PREFERENCE_DATA.dashboard.overview;
            }
        }
        if (parsedData.openInterest == undefined) {
            parsedData.openInterest = PREFERENCE_DATA.openInterest;
        }
        else {
            if (parsedData.openInterest.openInterest == undefined ||
                parsedData.openInterest.openInterest.selectedScrip == undefined ||
                parsedData.openInterest.openInterest.selectedExpiry == undefined) {
                parsedData.openInterest.openInterest =
                    PREFERENCE_DATA.openInterest.openInterest;
            }
            if (parsedData.openInterest.multiStrike == undefined ||
                parsedData.openInterest.multiStrike.selectedScrip == undefined ||
                parsedData.openInterest.multiStrike.strikes == undefined ||
                parsedData.openInterest.multiStrike.timeSelected == undefined ||
                parsedData.openInterest.multiStrike.viewMode == undefined ||
                parsedData.openInterest.multiStrike.timeSelectedTable == undefined ||
                parsedData.openInterest.multiStrike.niftyCallFrom == undefined ||
                parsedData.openInterest.multiStrike.niftyCallTo == undefined ||
                parsedData.openInterest.multiStrike.niftyPutFrom == undefined ||
                parsedData.openInterest.multiStrike.niftyPutTo == undefined ||
                parsedData.openInterest.multiStrike.bNiftycallFrom == undefined ||
                parsedData.openInterest.multiStrike.bNiftycallTo == undefined ||
                parsedData.openInterest.multiStrike.bNiftyputFrom == undefined ||
                parsedData.openInterest.multiStrike.bNiftyputTo == undefined) {
                parsedData.openInterest.multiStrike =
                    PREFERENCE_DATA.openInterest.multiStrike;
            }
            if (parsedData.openInterest.combinedOI == undefined ||
                parsedData.openInterest.combinedOI.selectedScrip == undefined ||
                parsedData.openInterest.combinedOI.timeSelected == undefined) {
                parsedData.openInterest.combinedOI =
                    PREFERENCE_DATA.openInterest.combinedOI;
            }
        }
        // if (parsedData.openInterest.multiStrike.viewMode == undefined) {
        //   parsedData.openInterest.multiStrike.viewMode =
        //     PREFERENCE_DATA.openInterest.multiStrike.viewMode;
        // }
        // if (parsedData.openInterest.multiStrike.timeSelectedTable == undefined) {
        //   parsedData.openInterest.multiStrike.timeSelectedTable =
        //     PREFERENCE_DATA.openInterest.multiStrike.timeSelectedTable;
        // }
        if (parsedData.optionChain == undefined ||
            parsedData.optionChain.selected == undefined ||
            parsedData.optionChain.selected.length == 0) {
            parsedData.optionChain = PREFERENCE_DATA.optionChain;
        }
        //TODO removed fno stats prefs
        // parsedData.fnoStats = PREFERENCE_DATA.fnoStats;
        if (parsedData.fnoStats == undefined) {
            parsedData.fnoStats = PREFERENCE_DATA.fnoStats;
        }
        else {
            if (parsedData.fnoStats.futureActivity == undefined ||
                parsedData.fnoStats.futureActivity.expiry == undefined) {
                parsedData.fnoStats.futureActivity =
                    PREFERENCE_DATA.fnoStats.futureActivity;
            }
            if (parsedData.fnoStats.futureIntraday == undefined ||
                parsedData.fnoStats.futureIntraday.contract == undefined ||
                parsedData.fnoStats.futureIntraday.duration == undefined ||
                parsedData.fnoStats.futureIntraday.expiry == undefined) {
                parsedData.fnoStats.futureIntraday =
                    PREFERENCE_DATA.fnoStats.futureIntraday;
            }
            if (parsedData.fnoStats.futureScreener == undefined ||
                parsedData.fnoStats.futureScreener.activity == undefined ||
                parsedData.fnoStats.futureScreener.expiry == undefined) {
                parsedData.fnoStats.futureScreener =
                    PREFERENCE_DATA.fnoStats.futureScreener;
            }
            if (parsedData.fnoStats.indexContributor == undefined ||
                parsedData.fnoStats.indexContributor.scrip == undefined) {
                parsedData.fnoStats.indexContributor =
                    PREFERENCE_DATA.fnoStats.indexContributor;
            }
            if (parsedData.fnoStats.indiaVix == undefined ||
                parsedData.fnoStats.indiaVix.index == undefined) {
                parsedData.fnoStats.indiaVix = PREFERENCE_DATA.fnoStats.indiaVix;
            }
            if (parsedData.fnoStats.optionScreener == undefined ||
                parsedData.fnoStats.optionScreener.activityIndex == undefined ||
                parsedData.fnoStats.optionScreener.activityStock == undefined ||
                parsedData.fnoStats.optionScreener.categoryType == undefined ||
                parsedData.fnoStats.optionScreener.expiryIndex == undefined ||
                parsedData.fnoStats.optionScreener.expiryStock == undefined) {
                parsedData.fnoStats.optionScreener =
                    PREFERENCE_DATA.fnoStats.optionScreener;
            }
            if (parsedData.fnoStats.optionsActivity == undefined ||
                parsedData.fnoStats.optionsActivity.expiry == undefined) {
                parsedData.fnoStats.optionsActivity =
                    PREFERENCE_DATA.fnoStats.optionsActivity;
            }
        }
        userPreference = parsedData;
        // if (
        //   parsedData.optionChain.length > 1 &&
        //   parsedData.optionChain[1].strike == undefined
        // ) {
        //   parsedData.optionChain[1] = PREFERENCE_DATA.optionChain[1];
        // }
        return parsedData;
    }
};
const setPreferences = (value) => __awaiter(void 0, void 0, void 0, function* () {
    if (value !== undefined) {
        //TODO removed fno stats prefs
        // value.fnoStats = PREFERENCE_DATA.fnoStats;
        userPreference = value;
        setDataInSession(SESSION_KEYS.PREFERENCE, value);
        setDataInSession(SESSION_KEYS.PREFERENCE_CHANGED, "true", true);
    }
});
const setPreferenceFirebase = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const value = getPreferences();
        const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
        if (Object.keys("global")) {
            delete value["global"];
        }
        setDataInSession(SESSION_KEYS.PREFERENCE_CHANGED, "false");
        //const resp = await setPreferencesApi(value, clientCode);
    }
    catch (error) {
        console.error(error);
    }
});
const getAmPmForEquity = (value) => {
    if (value.substr(0, 2) >= 9 && value.substr(0, 2) < 12) {
        return value + " AM";
    }
    else {
        return value + " PM";
    }
};
// const checkAndGetDepthToken = (): string | undefined => {
//   const depthResponseString = localStorage.getItem(DEPTH_TOKEN_DATA);
//   if (depthResponseString) {
//     const depthResponse: {
//       token_type: string;
//       expires_in: number;
//       access_token: string;
//       timeStamp: string;
//     } = JSON.parse(depthResponseString);
//     const timeStamp = moment(depthResponse.timeStamp).add(
//       depthResponse.expires_in,
//       "seconds"
//     );
//     if (timeStamp.isAfter(moment())) {
//       return depthResponse.access_token;
//     } else {
//       localStorage.removeItem(DEPTH_TOKEN_DATA);
//     }
//   }
//   return undefined;
// };
const checkAndGetDepthToken = () => {
    return new Promise((resolve, reject) => {
        const depthResponseString = getDataFromSession(SESSION_KEYS.dEPTH_TOKEN_RESPONSE);
        if (depthResponseString) {
            const depthResponse = depthResponseString;
            const timeStamp = moment(depthResponse.timeStamp).add(depthResponse.expires_in, "seconds");
            if (timeStamp.isAfter(moment())) {
                resolve(depthResponse.access_token);
                return;
            }
            else {
                removeFromSession(SESSION_KEYS.dEPTH_TOKEN_RESPONSE);
            }
        }
        const currentTimeStamp = new Date().toString();
        // getOneLoginToken()
        //   .then(
        //     (tokenResp) => {
        //       const depthResponse = tokenResp.data;
        //       depthResponse.timeStamp = currentTimeStamp;
        //       setDataInSession(
        //         SESSION_KEYS.dEPTH_TOKEN_RESPONSE,
        //         JSON.stringify(depthResponse),
        //         true
        //       );
        //       resolve(depthResponse.access_token);
        //     },
        //     (error) => {
        //       reject(error);
        //     }
        //   )
        //   .catch((error) => {
        //     reject(error);
        //   });
    });
};
const checkAndGetGreeksToken = () => {
    return new Promise((resolve, reject) => {
        const greeksResponseString = localStorage.getItem(GREEKS_TOKEN_DATA);
        if (greeksResponseString) {
            const GreeksTokenResponse = JSON.parse(greeksResponseString);
            const timeStamp = moment(GreeksTokenResponse.timeStamp).add(GreeksTokenResponse.expires_in, "seconds");
            //console.log(timeStamp,moment(),"==========");
            if (timeStamp.isAfter(moment())) {
                resolve(GreeksTokenResponse.access_token);
                return;
            }
            else {
                localStorage.removeItem(GREEKS_TOKEN_DATA);
            }
        }
        const currentTimeStamp = new Date().toString();
        getChartTokenSocket()
            .then((tokenResp) => {
            const tokenResponse = tokenResp;
            tokenResponse.data.timeStamp = currentTimeStamp;
            localStorage.setItem(GREEKS_TOKEN_DATA, JSON.stringify(tokenResponse.data));
            resolve(tokenResponse.access_token);
        }, (error) => {
            reject(error);
        })
            .catch((error) => {
            reject(error);
        });
    });
};
const getNearestExpData = (arr, symbol, expiryMilliseconds) => {
    arr = arr.filter((item) => item.Symbol == symbol);
    let nearestFutureDataTemp;
    let selectedTimeString = 0;
    if (expiryMilliseconds) {
        const filterArr = arr.filter((item) => {
            const expiryMonth = new Date(Number(expiryMilliseconds)).getMonth();
            const splitString = item.Expiry.split("(");
            const timeString = splitString[1].split("+")[0];
            const monthForTimeString = new Date(Number(timeString)).getMonth();
            return monthForTimeString === expiryMonth;
        });
        if (filterArr.length === 0) {
            nearestFutureDataTemp = arr[arr.length - 1];
        }
        else {
            // Filter the selected expiry for SENSEX & monthly expiry for others.
            if (symbol.toUpperCase() == "SENSEX") {
                const filterDateArr = filterArr.filter((item) => {
                    const expiryDate = new Date(Number(expiryMilliseconds)).getDate();
                    const splitString = item.Expiry.split("(");
                    const timeString = splitString[1].split("+")[0];
                    const dateForTimeString = new Date(Number(timeString)).getDate();
                    return dateForTimeString === expiryDate;
                });
                if (filterDateArr.length == 0) {
                    nearestFutureDataTemp = filterArr[filterArr.length - 1];
                }
                else {
                    nearestFutureDataTemp = filterDateArr[0];
                }
            }
            else {
                nearestFutureDataTemp = filterArr[filterArr.length - 1];
            }
        }
    }
    else {
        arr.forEach((singleElement) => {
            const timeInMillis = getStartOfTheDayTime();
            const splitString = singleElement.Expiry.split("(");
            const timeString = splitString[1].split("+")[0];
            if (parseFloat(timeString) > timeInMillis) {
                if (nearestFutureDataTemp) {
                    if (selectedTimeString > parseFloat(timeString)) {
                        nearestFutureDataTemp = singleElement;
                        selectedTimeString = parseFloat(timeString);
                    }
                }
                else {
                    nearestFutureDataTemp = singleElement;
                    selectedTimeString = parseFloat(timeString);
                }
            }
        });
    }
    return nearestFutureDataTemp;
};
// const tokenResp = await getOneLoginToken();
const getscripCode = (symbol, exch, exchType) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = `IndexId eq -1 and Exch eq '${exch}' and ExchType eq '${exchType}'`;
    const response = yield getElasticSearchDataNew(parseSearchstring(symbol), 0, filterString || "");
    const scripcode = response.data.value.length > 0 ? response.data.value[0] : {};
    return scripcode;
});
const getSmartStrategiesKey = () => {
    const algoKey = getDataFromSession(SESSION_KEYS.SMART_ALGO_KEY);
    if (algoKey) {
        return algoKey;
    }
    else {
        return AUTORIZATION_SMART_STRATEGIES;
    }
};
const getCurrentDomainPath = () => {
    let domainName = window.location.hostname;
    if (domainName == "dev.5paisa.in") {
        domainName = "http://" + domainName + "/";
    }
    else {
        domainName = "https://" + domainName + "/";
    }
    return domainName;
};
const getCurrentDomainPathWithparams = () => {
    const domainName = window.location.href;
    return domainName;
};
const checkAndGetOsName = () => {
    let detectedOS = "UNKNOWN";
    if (navigator.appVersion.indexOf("Mac") != -1)
        detectedOS = "MACOS";
    if (navigator.appVersion.indexOf("Win") != -1)
        detectedOS = "WINDOWS";
    if (navigator.appVersion.indexOf("Linux") != -1)
        detectedOS = "LINUX";
    return detectedOS;
};
const getBrowserName = () => {
    const userAgent = navigator.userAgent;
    let browserName;
    if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "CHROME";
    }
    else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "FIREFOX";
    }
    else if (userAgent.match(/safari/i)) {
        browserName = "SAFARI";
    }
    else if (userAgent.match(/opr\//i)) {
        browserName = "OPERA";
    }
    else if (userAgent.match(/edg/i)) {
        browserName = "EDGE";
    }
    else {
        browserName = "UNKNOWN";
    }
    return browserName;
};
const encryptQuantsappData = () => {
    const generatedString = `${getDataFromSession(SESSION_KEYS.CLIENT_CODE)}` +
        "|" +
        new Date().getTime().toString();
    const pass = REACT_APP_QUANTSAPP_KEY ? REACT_APP_QUANTSAPP_KEY : "";
    const keyEnyDec = CryptoJS.enc.Base64.parse(btoa(pass));
    const enycOptions = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    };
    const encryptKey = CryptoJS.AES.encrypt(generatedString, keyEnyDec, enycOptions).toString();
    return encodeURIComponent(encryptKey);
};
const getOptionChainTrendName = (lastPrice, LTP, oiZero) => {
    let trend = "-";
    if (oiZero) {
        if (LTP < lastPrice) {
            trend = "SB";
        }
        else if (LTP > lastPrice) {
            trend = "LB";
        }
    }
    else {
        if (lastPrice > 0 && LTP > 0) {
            trend = "LB";
        }
        else if (lastPrice < 0 && LTP > 0) {
            trend = "SB";
        }
        else if (lastPrice < 0 && LTP < 0) {
            trend = "LU";
        }
        else if (lastPrice > 0 && LTP < 0) {
            trend = "SC";
        }
    }
    return trend;
};
const getExitPrice = (advisoryTradeItem) => {
    let exitPrice;
    if (advisoryTradeItem.Call == "Close") {
        if (advisoryTradeItem.Status == "Profit Booked" ||
            advisoryTradeItem.Status == "Target Achieved") {
            exitPrice =
                advisoryTradeItem.New_Exit_Price.length > 0
                    ? advisoryTradeItem.New_Exit_Price
                    : advisoryTradeItem.Exit_price;
        }
        else if (advisoryTradeItem.Status == "Stoploss Triggered" ||
            advisoryTradeItem.Status == "Revised Stoploss Triggered" ||
            advisoryTradeItem.Status == "Stop loss triggered" ||
            advisoryTradeItem.Status == "Exit") {
            exitPrice = advisoryTradeItem.New_Stop_loss_Price
                ? advisoryTradeItem.New_Stop_loss_Price
                : advisoryTradeItem.Stop_loss_Price;
        }
        else {
            exitPrice = "-";
        }
    }
    else {
        exitPrice = "-";
    }
    return exitPrice;
};
const getValueOrZero = (inputValue) => {
    if (inputValue == undefined) {
        return 0;
    }
    else {
        return inputValue;
    }
};
const getNumberFromCommaSeparatedValue = (inputValue) => {
    if (isEmpty(inputValue)) {
        return 0;
    }
    else {
        try {
            const convertValue = Number(inputValue.replaceAll(",", ""));
            return isNaN(convertValue) ? 0 : convertValue;
        }
        catch (error) {
            console.error(error);
            return 0;
        }
    }
};
const getGreekOptions = () => {
    return DEFAULT_GREEK_OPTIONS;
};
const isNumeric = (str) => {
    return (!isNaN(Number(str)) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str))); // ...and ensure strings of whitespace fail
};
const getJwtToken = () => {
    let jwtValue = getDataFromSession(SESSION_KEYS.JWTTOKEN) || "";
    if (jwtValue) {
        jwtValue = jwtValue.replace("JwtToken=", "").trim();
        jwtValue = jwtValue.replace("jwtToken=", "").trim();
        jwtValue = jwtValue.replace("jwttoken=", "").trim();
    }
    return jwtValue;
};
const getNearestExpDataOptionChain = (arr, symbol, expiryMilliseconds) => {
    // arr = arr.filter((item) => item.symbol == symbol && item.Exchange == "N");
    let nearestFutureDataTemp;
    let selectedTimeString = 0;
    if (expiryMilliseconds) {
        const filterArr = arr.filter((item) => {
            const validMilliSec = expiryMilliseconds.includes("(")
                ? expiryMilliseconds.split("(")[1]
                : expiryMilliseconds;
            const expiryMonth = new Date(Number(validMilliSec)).getMonth();
            if (item.ExpiryDate.includes("T")) {
                const monthForTimeString = new Date(item.ExpiryDate).getMonth();
                return monthForTimeString === expiryMonth;
            }
            else {
                const splitString = item.ExpiryDate.split("(");
                const timeString = splitString[1].split("+")[0];
                const monthForTimeString = new Date(Number(timeString)).getMonth();
                return monthForTimeString === expiryMonth;
            }
        });
        if (filterArr.length === 0) {
            nearestFutureDataTemp = arr[arr.length - 1];
        }
        else {
            if (symbol.toUpperCase() == "SENSEX") {
                const filterDateArr = filterArr.filter((item) => {
                    const expiryDate = new Date(Number(expiryMilliseconds)).getDate();
                    const splitString = item.ExpiryDate.split("(");
                    const timeString = splitString[1].split("+")[0];
                    const dateForTimeString = new Date(Number(timeString)).getDate();
                    return dateForTimeString === expiryDate;
                });
                if (filterDateArr.length == 0) {
                    nearestFutureDataTemp = filterArr[filterArr.length - 1];
                }
                else {
                    nearestFutureDataTemp = filterDateArr[0];
                }
            }
            else {
                nearestFutureDataTemp = filterArr[filterArr.length - 1];
            }
        }
    }
    else {
        arr.forEach((singleElement) => {
            const timeInMillis = getStartOfTheDayTime();
            const splitString = singleElement.ExpiryDate.split("(");
            const timeString = splitString[1].split("+")[0];
            if (parseFloat(timeString) > timeInMillis) {
                if (nearestFutureDataTemp) {
                    if (selectedTimeString > parseFloat(timeString)) {
                        nearestFutureDataTemp = singleElement;
                        selectedTimeString = parseFloat(timeString);
                    }
                }
                else {
                    nearestFutureDataTemp = singleElement;
                    selectedTimeString = parseFloat(timeString);
                }
            }
        });
    }
    return nearestFutureDataTemp;
};
const formatDuration = (durationInMilliseconds) => {
    const seconds = Math.floor(durationInMilliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days > 0) {
        return days + " days, " + (hours % 24) + " hours";
    }
    else if (hours > 0) {
        return (hours +
            " hours, " +
            (minutes % 60) +
            " minutes" +
            (seconds % 60) +
            " seconds");
    }
    else if (minutes > 0) {
        return minutes + " minutes, " + (seconds % 60) + " seconds";
    }
    else {
        return seconds + " seconds";
    }
};
const uintToJson = (uintArray) => {
    const encodedString = String.fromCharCode.apply(null, Array.from(uintArray));
    const decodedString = decodeURIComponent(escape(atob(encodedString)));
    return JSON.parse(decodedString);
};
const jsonToUint = (inputValue) => {
    const string = JSON.stringify(inputValue);
    return stringToUint(string);
};
const stringToUint = (inputValue) => {
    const string = btoa(unescape(encodeURIComponent(inputValue)));
    const charList = string.split("");
    const uintArray = [];
    for (let i = 0; i < charList.length; i++) {
        uintArray.push(charList[i].charCodeAt(0));
    }
    return new Uint8Array(uintArray);
};
const uintToString = (uintArray) => {
    const encodedString = String.fromCharCode.apply(null, Array.from(uintArray));
    const decodedString = decodeURIComponent(escape(atob(encodedString)));
    return decodedString;
};
const numberRoundingZeroFixed = (value) => {
    if (value === "-0.00" ||
        value === "+0.00" ||
        value === "Infinity" ||
        value === "NaN" ||
        value === "undefined" ||
        value === "")
        return "0.00";
    else
        return value;
};
const showToasterMsg = () => {
    if (!toastMessageEnabled) {
        ToastUtils.error("Max capacity to add strike is 10.", {
            autoClose: 3000,
        });
        toastMessageEnabled = true;
        setTimeout(() => {
            toastMessageEnabled = false;
        }, 3500);
    }
};
const generateRandom = () => {
    const value = Math.random() * 100;
    return value;
};
const parseTopic = (topic) => {
    // Split the topic using '/'
    const parts = topic.split("/");
    // Ensure that the topic has at least four parts
    if (parts.length < 4) {
        throw new Error("Invalid topic format");
    }
    // Extract the scripcode
    const scripcodePart = parts[4];
    const exchange = scripcodePart.charAt(0);
    const exchangeType = scripcodePart.charAt(1);
    const scripcode = scripcodePart.substring(2);
    return { scripcode, exchange, exchangeType };
};
const getMethodTypeFromTopic = (topicName) => {
    if (topicName.includes(SOLACE_20DEPTH_TOPIC_PREFIX)) {
        return SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE;
    }
    else if (topicName.includes(SOLACE_GREEKS_TOPIC_PREFIX)) {
        return SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS;
    }
    else {
        return "";
    }
};
const intFromBytes = (byteArray) => {
    let value = 0;
    for (let i = byteArray.length - 1; i >= 0; i--) {
        value = value * 256 + byteArray[i];
    }
    return value;
};
const floatFromBytes = (byteArray) => {
    const buffer = new ArrayBuffer(4);
    const dataView = new DataView(buffer);
    // const number = byteArray.wrap(4).getFloat()
    byteArray.forEach((value, index) => {
        dataView.setUint8(index, value);
    });
    return dataView.getFloat32(0, true); // The "true" argument specifies little-endian byte order, change to "false" for big-endian
};
const shortFromBytes = (byteArray) => {
    // if (byteArray.length < 2) {
    //   throw new Error("Byte array too short to convert to short");
    // }
    // short result = (short) ((byteArray[0] & 0xFF) | (byteArray[1] << 8));
    return (byteArray[0] & 0xff) | (byteArray[1] << 8);
    // (byteArray[0] << 8) | byteArray[1];
};
const charFromBytes = (byteArray) => {
    // if (byteArray.length !== 1) {
    //   throw new Error(
    //     "Byte array should contain exactly one byte to convert to a character"
    //   );
    // }
    const charCode = byteArray[0];
    return String.fromCharCode(charCode);
};
const generateRandomRemoteId = () => {
    const remoteId = (new Date().getTime() + Math.floor(Math.random() * 1000)).toString();
    return remoteId;
};
export const getVttOrderStatus = (data) => {
    let statusText = "", statusCSS;
    if ((data === null || data === void 0 ? void 0 : data.SLOrderStatus) === VTT_STATUS.TRIGGERED) {
        statusText = VTT_STATUS.SL_TRIGGERED;
        statusCSS = `spanForExecuted me-1`;
    }
    else if ((data === null || data === void 0 ? void 0 : data.ProfitOrderStatus) === VTT_STATUS.TRIGGERED) {
        statusText = VTT_STATUS.TGT_TRIGGERED;
        statusCSS = `spanForExecuted me-1`;
    }
    else if ((data === null || data === void 0 ? void 0 : data.InitialOrderStatus) === VTT_STATUS.EXECUTED ||
        (data === null || data === void 0 ? void 0 : data.InitialOrderStatus) === VTT_STATUS.TRIGGERED ||
        (data === null || data === void 0 ? void 0 : data.InitialOrderStatus.includes("Triggered | Executed"))) {
        statusText = VTT_STATUS.TRIGGERED;
        statusCSS = `spanForExecuted me-1`;
    }
    else if ((data === null || data === void 0 ? void 0 : data.InitialOrderStatus) === VTT_STATUS.PENDING) {
        if ((data === null || data === void 0 ? void 0 : data.InitialStatus) === "M" ||
            (data === null || data === void 0 ? void 0 : data.SLStatus) === "M" ||
            (data === null || data === void 0 ? void 0 : data.ProfitStatus) === "M") {
            statusText = VTT_STATUS.MODIFIED;
            statusCSS = `spanForModified me-1`;
        }
        else {
            statusText = VTT_STATUS.PENDING;
            statusCSS = `spanForPending me-1`;
        }
    }
    else if ((data === null || data === void 0 ? void 0 : data.InitialOrderStatus) === VTT_STATUS.CANCELLED) {
        statusText = VTT_STATUS.CANCELLED;
        statusCSS = `spanForCancelled me-1`;
    }
    return { statusText, statusCSS };
};
function gcd(a, b) {
    if (a == 0)
        return b;
    if (b == 0)
        return a;
    return gcd(b % a, a);
}
function getGCD(arr, n) {
    let result = arr[0];
    for (let i = 1; i < n; i++) {
        if (arr[i] !== 0 && result !== 0) {
            result = Math.floor(gcd(arr[i], result));
        }
        else {
            result = 1;
        }
        if (result == 1) {
            return 1;
        }
    }
    if (result > 0) {
        return Math.round(result);
    }
    else {
        return 1;
    }
}
const getPriceOcRowsHeight = () => {
    var _a, _b, _c, _d;
    const tableHeader = (_b = (_a = document.getElementById("table-Header")) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
    const middleHeader = (_d = (_c = document.getElementById("middle-Header")) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0;
    const listHeight = window.innerHeight - tableHeader - middleHeader - 80;
    return listHeight;
};
const getGreeksOcRowsHeight = () => {
    var _a, _b, _c, _d;
    const tableHeader = (_b = (_a = document.getElementById("table-Header")) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
    const middleHeader = (_d = (_c = document.getElementById("middle-Header")) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0;
    const listHeight = window.innerHeight - tableHeader - middleHeader - 40;
    return listHeight;
};
const getTextColorFromString = (text) => {
    if (text[0] === "+") {
        return "positiveText";
    }
    else if (text[0] === "-") {
        return "negativeText";
    }
    else {
        return "";
    }
};
//Convert month dd yyyy hh:mm AM/PM to -->dd month'yy
function formatStringDate(inputDate) {
    if (inputDate === undefined ||
        inputDate === null ||
        inputDate === "" ||
        inputDate.toLocaleLowerCase() === "n.a")
        return "-";
    inputDate = inputDate.replace("  ", " ");
    // ("Jul  5 2024 11:59PM");
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    // Split the input date string into components
    // debugger;
    let parts = inputDate.split(" ");
    let month = parts[0]; // Month abbreviation (e.g., "Jul")
    let day = parts[1]; // Day of the month (e.g., "1")
    let year = parts[2]; // Year (e.g., "2024")
    let time = parts[3]; // Time in hh:mmAM/PM format (e.g., "12:00AM")
    // Extract hour and minute from the time string
    let hour = parseInt(time.split(":")[0], 10);
    let minute = parseInt(time.split(":")[1].slice(0, 2), 10); // Remove 'AM' or 'PM'
    // Determine if it's AM or PM
    // debugger;
    let period = time.slice(-2);
    // Convert hour to 24-hour format if necessary
    if (period === "PM" && hour < 12) {
        hour += 12;
    }
    else if (period === "AM" && hour === 12) {
        hour = 0; // Midnight edge case
    }
    // Format the date
    let formattedDate = `${day} ${months[months.indexOf(month)].toUpperCase()}'${year.slice(-2)} ${hour
        .toString()
        .padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
    return formattedDate;
}
const classifyBulkOrderType = (arr, keyName, keyValues, returnValues) => {
    for (let i = 0; i < keyValues.length; i++) {
        if (arr.every((item) => item[keyName] === keyValues[i])) {
            return returnValues[i];
        }
    }
    return returnValues[returnValues.length - 1];
};
const getHandleKeyDown = (e, priceValue, tickSize, exchangeType) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
        e.preventDefault();
        let currentPrice = parseFloat(priceValue);
        if (isNaN(currentPrice)) {
            currentPrice = 0;
        }
        if (e.key === "ArrowUp") {
            currentPrice += parseFloat(tickSize);
            const temp = Number((parseFloat(priceValue) % parseFloat(tickSize)).toFixed(2));
            const temp1 = Number((Math.round(currentPrice / parseFloat(tickSize)) * parseFloat(tickSize)).toFixed(2));
            const temp2 = temp !== parseFloat(tickSize) &&
                temp > Number((parseFloat(tickSize) / 2.5).toFixed(2))
                ? Number(tickSize)
                : 0;
            currentPrice = (temp1 - temp2).toFixed(2);
        }
        else if (e.key === "ArrowDown") {
            currentPrice -= parseFloat(tickSize);
            const temp = Number((parseFloat(priceValue) % parseFloat(tickSize)).toFixed(2));
            const temp1 = Number((Math.round(currentPrice / parseFloat(tickSize)) * parseFloat(tickSize)).toFixed(2));
            const temp2 = temp !== parseFloat(tickSize) && !temp
                ? 0
                : temp < Number((parseFloat(tickSize) / 2.5).toFixed(2))
                    ? Number(tickSize)
                    : 0;
            currentPrice = (temp1 + temp2).toFixed(2);
        }
        return currentPrice;
    }
};
export { calculateAveragePriceAsPerFilter, calculateNetQuantity, calculateSellAveragePrice, checkAndGetDepthToken, checkAndGetGreeksToken, checkAndGetOsName, checkIsEmpty, convertNumberIntoLakhsAndCroreWithSign, convertNumberToShortText, copyTextToClipboard, currencyDecimal, displayDigits, encrypt, encryptQuantsappData, filterUserWatchList, getAfterMarketHours, getAmPmForEquity, getBase64EncryptedText, getBookedPl, getBrowserName, getBuySellFromPostionItem, getChangeAndChangePercentage, getChangeAndChangePercentageWithoutSign, getChartUrl, getCookie, getCurrentDomainPath, getDateTimestampFromDate, getDefaultDateFormat, getDisplayTextFromExchange, getEnvironmentVariableOrEmpty, getExchFromDisplayText, getExhangeColor, getExhangeTypeColor, getExitPrice, getFormattedDate, getFormattedNameFromNameBreakup, getFormattedNameFromString, getGreekOptions, getJsonFromXml, getJwtToken, getMillisFromDateString, getNearestExpData, getNearestExpDataOptionChain, getNearestExpiryElement, getNumberFromCommaSeparatedValue, getOptionChainTrendName, getOptionExpiryListWithCaching, getOptionsFromSymbolWithCaching, getExpiryDateOptionChainWithCaching, getAllOptionChainExpiryListWithCaching, getOrderBookCaching, getOrderFor, getOrderType, getOrderValidityFromDayType, getPreferences, getScripType, getSearchFilteredData, getSegmentAndProductType, getSmartStrategiesKey, getStartOfTheDayTime, getStatusColor, getBasketAdvisoryClosedAtValue, getStatusForOrderData, getStockNameFromSearchData, getStrike, getSymbols, getToken, getUnrealizedPL, getValueOrZero, getscripCode, handleDecimalLimit, intComma, intCommaWithoutDecimal, isNumeric, nearestNumberRoundOff, onRenderCallback, getBase64DecryptedAccessList, openChartTab, parseSearchstring, plCalculation, plCalculation_simple, redirectToCDSL, setPreferenceFirebase, setPreferences, splitAndGetDetailsFromLongName, splitSrikeBySpace, triggerDate, formatDuration, convertToMillisfromDateString, numberRoundingZeroFixed, uintToJson, jsonToUint, stringToUint, uintToString, showToasterMsg, getCurrentDomainPathWithparams, getMWPLBanListApiWithWorker, generateRandom, getStockInfoChart, parseTopic, intFromBytes, floatFromBytes, charFromBytes, shortFromBytes, getMethodTypeFromTopic, generateRandomRemoteId, getGCD, getStrategyBuilderPayoffNewWithWorker, getPriceOcRowsHeight, getGreeksOcRowsHeight, isMultiple, getTextColorFromString, epochToDate, formatStringDate, classifyBulkOrderType, getHandleKeyDown, };
